
export default {
  data() {
    return {
      title: "History | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
    };
  },
};
